/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import { Dictionary } from "lodash";
import Slider, { Settings } from "react-slick";

import { IDayEpochInfo } from "../../../../models/util/IDayEpochInfo";
import { IFetchScheduledInterventionsResponse, INTERVENTIONS_STATUS } from "../../../../models/IFetchScheduledInterventions";
import AppUtils from "../../../../utils/AppUtils";

import { interventionsDailyViewStylesMobile } from "./InterventionDailyViewStyles";
import { StatusIndicator } from "../../StatusIndicator";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Card } from "../../../common/Card";


interface IIntervantionsDailyViewProps {
    dateList: IDayEpochInfo[];
    data: Dictionary<IFetchScheduledInterventionsResponse[]>;
    onDailyViewFwd(): void;
    onDailyViewBack(): void
    isMobile: boolean;
    getDataForCurrentDate(currentRowData: IFetchScheduledInterventionsResponse[], startEpoch: number, endEpoch: number): IFetchScheduledInterventionsResponse;
    getIconImageUrl(scheduledPlanCategory: string): string;
}


export const InterventionDailyViewMobile: React.FC<IIntervantionsDailyViewProps> = props => {

    const carousalSettings: Settings = {
        dots: true,
        infinite: false,
        slidesToShow: 2.2,
        slidesToScroll: 2,
        swipeToSlide: true,
        arrows: false
    }


    const { dateList, data, onDailyViewBack, onDailyViewFwd, getDataForCurrentDate, getIconImageUrl } = props;
    const weekStartDate = AppUtils.getFormattedShortDate(dateList[0].startEpoch);
    const weekEndDate = AppUtils.getFormattedShortDate(dateList[dateList.length - 1].startEpoch);

    const getItems = () => {
        let slideItems: JSX.Element[] = [];
        slideItems = dateList.map((dates, index) => {
            return (
                <div key={`slide-${index}`}>
                    <div css={interventionsDailyViewStylesMobile.dateHeaderWrapper} className="activity-data">
                        <span css={interventionsDailyViewStylesMobile.dateHeader}>{dates.display}</span>
                        <span css={interventionsDailyViewStylesMobile.dateHeader}>{dates.dayShortForm}</span>
                    </div>
                    <div css={interventionsDailyViewStylesMobile.divider}></div>
                    {
                        Object.keys(data).map(key => {
                            let dataForCurrentDate = getDataForCurrentDate(data[key], dates.startEpoch, dates.endEpoch);
                            return (
                                <div css={interventionsDailyViewStylesMobile.tableCols} className="activity-data" key={`${key}-${index}`}>
                                    <StatusIndicator status={dataForCurrentDate && dataForCurrentDate.status} />
                                </div>)
                        })}
                </div>)
        })
        return slideItems;
    }


    return (
        <Card>
            <div css={interventionsDailyViewStylesMobile.summaryContainer}>
                <div css={interventionsDailyViewStylesMobile.headerWrapper}>
                    <div css={interventionsDailyViewStylesMobile.cardHeaderText}>Daily View</div>
                    <div css={interventionsDailyViewStylesMobile.weekDatesWrapper}>
                        <img src="/images/back-frwd.svg" css={interventionsDailyViewStylesMobile.backIcon} onClick={onDailyViewBack} />
                        <span css={interventionsDailyViewStylesMobile.weekDate}>{weekStartDate}</span>
                        <span css={interventionsDailyViewStylesMobile.separator}> - </span>
                        <span css={interventionsDailyViewStylesMobile.weekDate}>{weekEndDate}</span>
                        <img src="/images/back-frwd.svg" css={interventionsDailyViewStylesMobile.forwardIcon} onClick={onDailyViewFwd} />
                    </div>
                </div>

                <div css={interventionsDailyViewStylesMobile.dailyViewContainer}>
                    <div css={interventionsDailyViewStylesMobile.leftContainer}>
                        <div css={interventionsDailyViewStylesMobile.tableHeader}>Activity List</div>
                        <div css={interventionsDailyViewStylesMobile.divider}></div>
                        <div css={interventionsDailyViewStylesMobile.activityList}>
                            {Object.keys(data).map(key => <React.Fragment key={`activityName-${key}`}>
                                {
                                    dateList && dateList.map((date, index) => {
                                        const itemName: string = data[key] && data[key][0] && data[key][0].lineItem.modifiedInterventionText;
                                        const scheduledPlanCategory: string = data[key] && data[key][0] && data[key][0].scheduledPlanCategory;
                                        const itemIconUrl: string = getIconImageUrl(scheduledPlanCategory);
                                        if (index === 0) {
                                            return (
                                                <div css={interventionsDailyViewStylesMobile.activityTableCols} key={index}>
                                                    <div css={{ display: "flex" }}>
                                                        <img src={itemIconUrl} css={interventionsDailyViewStylesMobile.iterventionNameIcon} />
                                                        <div css={interventionsDailyViewStylesMobile.iterventionNameText}>{itemName}</div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </React.Fragment>)
                            }
                        </div>
                    </div>
                    <div css={interventionsDailyViewStylesMobile.middleContainer}>
                        <div css={interventionsDailyViewStylesMobile.divider}></div>
                    </div>
                    <div css={interventionsDailyViewStylesMobile.rightContainer}>
                        {/* <div css={SliderItem}> */}
                        <Slider {...carousalSettings}>
                            {getItems()}
                        </Slider>
                        {/* </div> */}
                    </div>

                </div>
            </div>
            <div css={interventionsDailyViewStylesMobile.divider}></div>
            <div css={interventionsDailyViewStylesMobile.legendContainer}>
                {
                    Object.keys(INTERVENTIONS_STATUS).map(status => <div css={interventionsDailyViewStylesMobile.legend} key={status}>
                        <StatusIndicator status={status as INTERVENTIONS_STATUS} />
                        <div css={interventionsDailyViewStylesMobile.legendText}>{status}</div>
                    </div>)
                }
            </div>
        </Card>
    )
}